import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconDoubleChevronRight', new SVGIconWithSizes(_defineProperty({}, IconSize.ExtraSmall, {
  paths: ['M3.5,13a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L6.09,8,2.79,4.71A1,1,0,0,1,4.21,3.29l4,4a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,3.5,13M8.5,13a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L11.09,8,7.79,4.71A1,1,0,0,1,9.21,3.29l4,4a1,1,0,0,1,0,1.42l-4,4A1,1,0,0,1,8.5,13Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
})));